import type { ScenarioResponse } from '../types';

/**
 * lastResult (ScenarioGenerator のローカル正本) の 1 シーンに部分更新を当てる純関数。
 *
 * シーン単位の小さな設定 (顔あり/顔なし・場面の割り当て等) の楽観更新に使う。
 * 保存 (PUT) の応答を待ってから書き換えると、controlled な select が応答までの間に
 * prop の古い値へ引き戻されて「元に戻された」ように見えるため、選んだ瞬間に当てて
 * 失敗時だけ元の値で当て直す。prev が null のときは何もしない。
 */
export function patchSceneInLastResult<T extends ScenarioResponse | null>(
  prev: T,
  sceneId: string,
  patch: Record<string, unknown>,
): T {
  if (!prev) return prev;
  return {
    ...prev,
    scenarios: prev.scenarios.map((s: any) => ({
      ...s,
      scenes: s.scenes.map((sc: any) => (sc.id === sceneId ? { ...sc, ...patch } : sc)),
    })),
  } as T;
}
